module.exports = __webpack_public_path__ + "media/new/success-icon-e9577301.svg";